








































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { CompanyAuditConfig } from '../models/company-audit-config';

@Component
export default class AuditConfig extends Vue {
  @Prop()
  private config: CompanyAuditConfig;

  @Emit('update')
  private handleChange(config: CompanyAuditConfig) {
    return config;
  }
}
